import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PopoutData } from '../../services/popout/PopoutData';

@Component({
  selector: 'digires-popout-print-instruction-dialog',
  templateUrl: './popout-print-instruction-dialog.component.html',
  styleUrls: ['./popout-print-instruction-dialog.component.scss']
})
export class PopoutPrintInstructionDialogComponent {}
